


import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import Select from 'react-select';

const AssignStudentToMentor = () => {
  const { mentorId } = useParams(); // get mentor_id from URL
const navigate=useNavigate();
  const [form, setForm] = useState({
    program_id: '',
    type: '',
    student_ids: [],
    mentor_id: mentorId,
  });

  const [programs, setPrograms] = useState([]);
  const [students, setStudents] = useState([]);

  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

  // Fetch programs & students when type changes
  useEffect(() => {
    if (form.type) {
      callAPI('get', `get-program-student-list/${form.type}`, '');
    }
  }, [form.type]);

  // Handle response for programs and students
  useEffect(() => {
    if (responce?.data) {
      const data = responce.data;

      if (Array.isArray(data.programs)) {
        setPrograms(data.programs);
      }

      if (Array.isArray(data.students)) {
        setStudents(data.students);
      }
    }
  }, [responce]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleStudentChange = (selectedOptions) => {
    const ids = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
    setForm({ ...form, student_ids: ids });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.program_id || !form.type || form.student_ids.length === 0) {
      alert("Please fill all fields and select at least one student.");
      return;
    }

    callAPI('post', 'admin/assign-student-to-mentor', form);
  };

  // Prepare student options for Select
  const studentOptions = students.map((student) => ({
    value: student.id,
    label: `${student.first_name} ${student.last_name}`,
  }));
  useEffect(()=>{
    if(statusCode===201){
      navigate('/mentor/list')
    }
  })

  return (
    <AdminAppBody
        loading={loading}

      content={
        <div className="container card mt-4 p-4">
          <h4>Assign Students to Mentor</h4>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Student Type</label>
              <select
                className="form-control"
                name="type"
                value={form.type}
                onChange={handleChange}
                required
              >
                <option value="">-- Select Student Type --</option>
                <option value="kids">Kids</option>
                <option value="student">Student</option>
              </select>
            </div>

            <div className="mb-3">
              <label>Program</label>
              <select
                className="form-control"
                name="program_id"
                value={form.program_id}
                onChange={handleChange}
                required
              >
                <option value="">-- Select Program --</option>
                {programs.map((prog) => (
                  <option key={prog.id} value={prog.id}>
                    {prog.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label>Students</label>
              <Select
                name="student_ids"
                value={studentOptions.filter((opt) =>
                  form.student_ids.includes(opt.value)
                )}
                onChange={handleStudentChange}
                options={studentOptions}
                isMulti
                isClearable
                placeholder="Select Students"
              />
            </div>

            <button type="submit" className="btn btn-primary">
              Assign
            </button>
          </form>
        </div>
      }
    />
  );
};

export default AssignStudentToMentor;
